import { ObjectsView } from "@organisms"

import { CREDIT_NOTES_ROUTES } from "@routes/creditNotes"

import { CreditNoteStatuses } from "@constants/choices"

export const CreditNoteObjectsViewTabs = () => (
    <ObjectsView.Tabs>
        <ObjectsView.Tab
            id="all_open"
            phase="open"
            title="All Open"
            isDefaultActiveTabForPhase={true}
            endpointKwargs={[
                ["status", CreditNoteStatuses.pending],
                ["ordering", "date_issued"],
            ]}
            listEndpoint={CREDIT_NOTES_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={CREDIT_NOTES_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="pending"
            phase="open"
            title="Pending"
            endpointKwargs={[
                ["status", CreditNoteStatuses.pending],
                ["ordering", "date_issued"],
            ]}
            listEndpoint={CREDIT_NOTES_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={CREDIT_NOTES_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="all_closed"
            phase="closed"
            title="All Closed"
            isDefaultActiveTabForPhase={true}
            endpointKwargs={[
                ["status", CreditNoteStatuses.issued],
                ["status", CreditNoteStatuses.voided],
                ["ordering", "-date_issued"],
            ]}
            listEndpoint={CREDIT_NOTES_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={CREDIT_NOTES_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="issued"
            phase="closed"
            title="Issued"
            endpointKwargs={[
                ["status", CreditNoteStatuses.issued],
                ["ordering", "-date_issued"],
            ]}
            listEndpoint={CREDIT_NOTES_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={CREDIT_NOTES_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="voided"
            phase="closed"
            title="Voided"
            endpointKwargs={[
                ["status", CreditNoteStatuses.voided],
                ["ordering", "-date_issued"],
            ]}
            listEndpoint={CREDIT_NOTES_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={CREDIT_NOTES_ROUTES.COUNT}
        />
    </ObjectsView.Tabs>
)
